import { LineReveal, FadeUp } from "./motion";

const PageHeader = ({ eyebrow, lines, description, dark = false, testid }) => (
  <header
    data-testid={testid}
    className={`pt-32 md:pt-44 pb-14 md:pb-20 ${dark ? "bg-[#1A1A1A] text-[#F7F5F2]" : "bg-[#F7F5F2]"}`}
  >
    <div className="max-w-[1600px] mx-auto px-5 md:px-10">
      <FadeUp>
        <p className={`eyebrow mb-6 ${dark ? "text-[#8C6A4F]" : "text-[#8C6A4F]"}`}>{eyebrow}</p>
      </FadeUp>
      <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[0.98] tracking-tight">
        {lines.map((line, i) => (
          <LineReveal key={i} text={line.text} className={line.italic ? "italic text-[#8C6A4F]" : ""} delay={0.1 + i * 0.12} />
        ))}
      </h1>
      {description && (
        <FadeUp delay={0.5}>
          <p className={`mt-8 max-w-2xl text-base md:text-lg leading-relaxed ${dark ? "text-[#F7F5F2]/75" : "text-[#5C5A56]"}`}>
            {description}
          </p>
        </FadeUp>
      )}
    </div>
  </header>
);

export default PageHeader;
